import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
export const TierPriceRowRange = ({
  tierRange
}) => {
  if (!tierRange.end) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "customerDataProperties.tieredPricing.table.range.infinite",
      options: {
        start: tierRange.start,
        infinityLabel: unescapedText('customerDataProperties.tieredPricing.table.range.infinityLabel')
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.tieredPricing.table.range.finite",
    options: {
      start: tierRange.start,
      end: tierRange.end
    }
  });
};